export default __webpack_public_path__ + "static/media/b-3.ee9ed762.jpeg";